/**
 * AGNOSTIC render of a word-level diff (version history).
 *
 * Paints the `diffWords` segments with theme-aware highlighting:
 *   · added (present in the NEW text)   → soft success background
 *   · removed (only in the old)         → soft danger background + strikethrough
 * Reusable for any versioned entity (VERSION_HISTORY guide).
 */
import { createMemo, For } from "solid-js";
import { diffWords } from "@apunte-digital/shared";

interface WordDiffProps {
  /** Old version text. */
  oldText: string;
  /** Current text (diff reference). */
  newText: string;
  class?: string;
}

export function WordDiff(props: WordDiffProps) {
  const segments = createMemo(() => diffWords(props.oldText, props.newText));
  return (
    <p
      class={`whitespace-pre-wrap break-words text-sm leading-[1.75] text-foreground ${props.class ?? ""}`}
      data-testid="word-diff"
    >
      <For each={segments()}>
        {(segment) =>
          segment.type === "equal" ? (
            segment.text
          ) : segment.type === "added" ? (
            <ins class="rounded-sm bg-success/20 px-0.5 no-underline" data-diff="added">
              {segment.text}
            </ins>
          ) : (
            <del
              class="rounded-sm bg-danger/10 px-0.5 text-muted-foreground line-through decoration-danger/50"
              data-diff="removed"
            >
              {segment.text}
            </del>
          )
        }
      </For>
    </p>
  );
}
